import { render, staticRenderFns } from "./TrainingPage.vue?vue&type=template&id=cf814054&scoped=true&"
import script from "./TrainingPage.vue?vue&type=script&lang=js&"
export * from "./TrainingPage.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPage.vue?vue&type=style&index=0&id=cf814054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf814054",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
